<form class="form operation-summary">
	<article class="content">
		<div class="grouped-list">
			<div class="group">
				<header class="group-header" *ngIf="warnings.length > 0">
					<div (click)="toggleWarningList()">
						<h3>
							<span translate="progress.summary.warnings"></span><span class="counter">{{ warnings.length }}</span>
						</h3>
						<stages-button-expand-collapse
							[isCollapsed]="!warningsExpanded"
							[classes]="'action menu-button'"
						></stages-button-expand-collapse>
					</div>
				</header>
				<div *ngIf="warningsExpanded">
					<ul class="list">
						<li class="list-item" *ngFor="let warn of warnings">
							<i class="ico ico-warning warning-color"></i> {{ warn }}
						</li>
					</ul>
				</div>
			</div>
		</div>
		<ul *ngIf="warnings.length == 0" class="list">
			<li class="list-item" translate="progress.summary.warnings.none"></li>
		</ul>
	</article>
</form>
<footer>
	<stages-buttons-bottom [removeBoundaries]="isDialog">
		<button *ngIf="showClearWarnings && warnings.length > 0" type="button" class="button lg cancel" (click)="clear()">
			<span translate="clearwarnings"></span>
		</button>
		<button *ngIf="!download" type="button" class="button lg" (click)="closed.emit()">
			<span translate="continue"></span>
		</button>
		<a *ngIf="download" [href]="download" class="button lg" role="button" (click)="closed.emit()"
			><span translate="download"></span
		></a>
	</stages-buttons-bottom>
</footer>
